export default [
  {
    path: "/",
    redirect: "two-wheeler-rental/models",
    name: "Home",
  },
  {
    path: "/two-wheeler-services",
    component: () => import("../screens/HomePage"),
    name: "Home",
    meta: { root: true },
  },
  {
    path: "/two-wheeler-services/blogs",
    component: () => import("../screens/TwlServices/BlogsPage"),
    meta: { product: "services" },
    name: "Two wheeler Blog",
  },
  {
    path: "/two-wheeler-services/blogs/:id",
    component: () => import("../screens/TwlServices/ViewBlogsPage"),
    meta: { product: "services" },
    name: "Two wheeler Blog View",
  },
  {
    path: "/two-wheeler-rental",
    component: () => import("../LandingPages/RentalsLanding"),
    name: "Two wheeler rentals landing",
  },
  {
    path: "/two-wheeler-loan-against-vehicle",
    component: () => import("../LandingPages/LoanAgainstVehicle"),
    meta: { product: "finance" },
    name: "Two wheeler Loan Against Vehicle",
  },
  {
    path: "/two-wheeler-loan-against-vehicle/faq",
    component: () => import("../screens/LoanAgainstVehicle/FaqSection"),
    meta: { product: "finance" },
    name: "Two wheeler Loan Against FAQ",
  },
  {
    path: "/two-wheeler-used-bike",
    component: () => import("../LandingPages/UsedBikeLanding"),
    meta: { product: "finance" },
    name: "Used Bike Homepage",
  },
  {
    path: "/two-wheeler-used-bike/bikes",
    component: () => import("../screens/usedBike/usedBikeHome"),
    meta: { product: "finance" },
    name: "Used Bikes Selecr",
  },
  {
    path: "*",
    component: () => import("../screens/redirectPages/404Error"),
    meta: { noindex: true },
  },
  {
    path: "/login",
    component: () => import("../screens/auth/LoginPage"),
    meta: { noindex: true },
  },
  {
    path: "/address-form",
    component: () => import("../components/AddressForm"),
    meta: { noindex: true },
  },
  {
    path: "/complaint-form",
    component: () => import("../components/GrievancePage"),
    meta: { noindex: true },
  },
  {
    path: "/uploads/upload-odometer",
    component: () => import("../screens/misc/uplaodOdomtereSearch.vue"),
    meta: { noindex: true },
    beforeEnter: authGuard,
  },
  {
    path: "/uploads/upload-odometer/:billId",
    component: () => import("../screens/misc/uplaodOdomtereForm.vue"),
    meta: { noindex: true },
    beforeEnter: authGuard,
  },

  {
    path: "/checkouts/km-bill/:billId/verify-payment",
    name: "VerifyPayment",
    component: () => import("../screens/misc/VerifyPayment.vue"),
    meta: { noindex: true },
    beforeEnter: authGuard,
  },

  {
    path: "/pickup-handoff/:bookingId",
    name: "PickupHandoff",
    component: () => import("../screens/misc/PickupHandoff.vue"),
    meta: { noindex: true },
  },

  {
    path: "/thank-you",
    component: () => import("../screens/redirectPages/ThankYou"),
    meta: { noindex: true },
  },

  {
    path: "/account",
    beforeEnter: authGuard,
    component: () => import("../screens/profile/ProfileHome"),
    meta: { noindex: true },
    children: [
      {
        path: "",
        component: () => import("../screens/profile/child/EditProfile"),
        meta: { showProfileRoute: true },
      },
      {
        path: "profile",
        component: () => import("../screens/profile/child/EditProfile"),
      },
      {
        path: "documents",
        component: () => import("../screens/profile/child/UserDocuments"),
      },
      {
        path: "address-book",
        component: () => import("../screens/profile/child/AddressList"),
      },
      {
        path: "refer-and-earn",
        component: () => import("../screens/profile/child/ReferEarn"),
      },
      {
        path: "points-and-penalties",
        component: () => import("../screens/profile/child/PointsAndPenalties"),
      },

      {
        path: "purchase",
        component: () => import("../screens/profile/child/purchaseList.vue"),
      },
      {
        path: "dailyRentalBookings",
        component: () =>
          import("../screens/profile/child/DailyRentalBookingList.vue"),
      },
      {
        path: "bookings/extend/:id",
        component: () =>
          import("../screens/profile/child/bookings/extendBooking"),
      },
      {
        path: "bookings",
        component: () => import("../screens/profile/child/BookingsList"),
        meta: { showProfileRoute: true },
        children: [
          {
            path: "",
            component: () =>
              import("../screens/profile/child/BookingsListCurrent"),
          },
          {
            path: "completed",
            component: () =>
              import("../screens/profile/child/BookingsListCompleted"),
          },
        ],
      },
    ],
  },

  {
    path: "/account/help-and-support",
    component: () => import("../screens/profile/child/HelpAndSupport"),
    meta: { noindex: true },
  },

  {
    path: "/feedback/:bookingId",
    component: () => import("../screens/misc/CustomerFeedback"),
    meta: { noindex: true },
  },
  {
    path: "/feedback/agent/:incidentId",
    component: () => import("../screens/misc/AgentCallFeedback"),
    meta: { noindex: true },
  },
  {
    path: "/feedback-submit/:otp",
    component: () => import("../screens/misc/FeedbackSubmit"),
    meta: { noindex: true },
  },
  {
    path: "/booking-redirect",
    component: () => import("../screens/redirectPages/FailedBooking"),
    meta: { noindex: true },
  },
  {
    path: "/success-booking",
    component: () => import("../screens/redirectPages/SuccessBooking"),
    meta: { noindex: true },
  },

  {
    path: "/help-and-support",
    beforeEnter: (to, from, next) => {
      window.location.href = "https://on-track.in";
      next(false);
    },
  },
  {
    path: "/help-and-support/*",
    beforeEnter: (to, from, next) => {
      window.location.href = `https://on-track.in/${to.params.pathMatch}`;
      next(false);
    },
  },
  {
    path: "/cash-free-test",
    component: () => import("../TestPages/CashfreeTest.vue"),
    meta: { noindex: true },
  },
  {
    path: "/two-wheeler-rental/daily/",
    component: () => import("../DailyRentals/MainPage.vue"),
    meta: {
      product: "dailyBikeRentals",
    },
  },
  {
    path: "/two-wheeler-rental/daily/models",
    name: "landingView",
    component: () => import("../DailyRentals/ModelSelection.vue"),
  },

  {
    path: "/vehicleDetails",
    component: () => import("../DailyRentals/vehicleDetails.vue"),
    beforeEnter: authGuard,
    meta: {
      hideFooter: true,
      noindex: true,
    },
  },
  {
    path: "/payment-statuses/:id",
    name: "paymentSuccess",
    component: () => import("../DailyRentals/paymentSuccess"),
    meta: { noindex: true },
  },
  {
    path: "/two-wheeler-rental/models",
    component: () => import("../screens/models/ModelList"),
  },
  {
    path: "/two-wheeler-rental/how-it-works",
    component: () => import("../screens/pages/HowItWorks"),
  },
  {
    path: "/two-wheeler-rental/models/:link",
    component: () => import("../screens/models/ModelDetails"),
  },
  {
    // Old id+slug model URL - kept as a redirect so existing shared/ad links keep working.
    path: "/two-wheeler-rental/models/:id/:link",
    redirect: (to) => `/two-wheeler-rental/models/${to.params.link}`,
  },
  {
    // Original model-display URL - kept standalone (not deleted) as a safety
    // net for any old ad links/bookmarks; redirects straight to the current
    // slug-only URL.
    path: "/model-display/:id/:link",
    redirect: (to) => `/two-wheeler-rental/models/${to.params.link}`,
  },
  {
    path: "/checkouts/:bookingId/payment-methods",
    component: () => import("../screens/pages/checkout/PaymentMethods"),
    meta: { noindex: true },
  },
  {
    name: "Verify Extension",
    path: "/checkouts/extension/:extendId/verify-payment",
    component: () =>
      import("../screens/pages/checkout/PaymentVerifyExtension.vue"),
    meta: { noindex: true },
  },
  {
    name: "Verify Booking",
    path: "/checkouts/booking/:bookingId/verify-payment",
    component: () =>
      import("../screens/pages/checkout/PaymentVerifyBooking.vue"),
    meta: { noindex: true },
  },
  {
    path: "/checkouts/:bookingId/payment-success",
    component: () => import("../screens/pages/checkout/PaymentSuccess"),
    meta: { noindex: true },
  },
  {
    path: "/resaleVehicleList/:id",
    name: "ResaleVehicleList",
    beforeEnter: authGuard,
    component: () => import("../vehicleResale/resaleVehicleList.vue"),
    meta: { noindex: true },
  },
  {
    path: "/:registrationNumber/vehicleDetails",
    name: "ResaleVehicleDetails",
    component: () => import("../vehicleResale/resaleVechicleDetails.vue"),
    meta: { noindex: true },
  },
  {
    path: "/purchase-order/:purchaseId",
    name: "PurchaseStatus",
    component: () => import("../vehicleResale/paymentConfirmation.vue"),
    meta: { noindex: true },
  },

  {
    path: "/account/notifications",
    name: "Account Notification",
    component: () => import("../screens/views/NotificationView"),
    meta: { noindex: true },
  },
  {
    path: "/bookings/extend/:id",
    component: () => import("../screens/profile/child/bookings/extendBooking"),
    meta: { noindex: true },
  },
  {
    path: "/ev/honda/swapping-networks",
    component: () => import("../screens/views/SwappingNetworks.vue"),
  },
  {
    path: "/ev/honda/periodic-service-center",
    component: () => import("../screens/views/ServiceCenterMap.vue"),
  },
];

function authGuard(to, from, next) {
  const token = localStorage.getItem("user-token");
  if (token) {
    next();
  } else {
    next({ path: "/login", query: { next: to.fullPath } });
  }
}
